import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    articles: require('@/data/articles.json'),
    articles2: require('@/data/articles2.json'),
    drawer: false,
    items: [
      {
        text: 'Home',
        href: '#!',
      },
      {
        text: 'About',
        href: '#about',
      },
    ],
  },
  getters: {
    categories: state => {
      const categories = []

      for (const article of state.articles) {
        if (
          !article.category ||
          categories.find(category => category.text === article.category)
        ) continue

        const text = article.category

        categories.push({
          text,
          href: '#!',
        })
      }

      return categories.sort().slice(0, 4)
    },
    links: (state, getters) => {
      return state.items.concat(getters.categories)
    },
    categories2: state => {
      const categories2 = []

      for (const article of state.articles2) {
        if (
          !article.category ||
          categories2.find(category => category.text === article.category)
        ) continue

        const text = article.category

        categories2.push({
          text,
          href: '#!',
        })
      }

      return categories2.sort().slice(0, 4)
    },
    links2: (state, getters) => {
      return state.items.concat(getters.categories2)
    },
  },
  mutations: {
    setDrawer: (state, payload) => (state.drawer = payload),
    toggleDrawer: state => (state.drawer = !state.drawer),
  },
  actions: {

  },
})
